import http from '../../../../api/http'

function retrieveOnlineJobFairApplicantCountListPaging(paramObj) {
    return http.post('/admin/ojf/onlineJobFair/retrieveOnlineJobFairApplicantCountListPaging', paramObj)
}

// 재직자/기업 - 상담 tab count
function retrieveApprovedCorpCountByOjfId(ojfId) {
    return http.get(`/admin/ojf/onlineJobFair/retrieveApprovedCorpCountByOjfId?ojfId=${ojfId}`);
}
// 재직자/기업 - 참가기업 리스트
function retrieveApprovedRecruitmentHallPaging(paramObj) {
    return http.post('/admin/ojf/recruitmentHall/retrieveApprovedRecruitmentHallPaging', paramObj)
}
// 재직자/기업 - 채용공고 리스트
function retrieveJobNoticeListPaging(paramObj) {
    return http.post('/admin/ojf/jobNotice/retrieveJobNoticeListPaging', paramObj)
}
// 재직자/기업 - 채용공고 - 입사지원 리스트
function retrieveOjfResumeListByByJobNoticeSeqAdminPaging(paramObj) {
    return http.post('/admin/ojf/ojfResume/retrieveOjfResumeListByByJobNoticeSeqAdminPaging', paramObj)
}
// 재직자/기업 - 입사지원 리스트
function retrieveAllOjfResumeListAdminPaging(paramObj) {
    return http.post('/admin/ojf/ojfResume/retrieveAllOjfResumeListAdminPaging', paramObj)
}
// 재직자/기업 - 참가(승인)기업 엑셀 다운로드
function retrieveApprovedRecruitmentHallStatusExcel(paramObj) {
    return http.post('admin/ojf/recruitmentHall/retrieveAllRecruitmentHallStatusExcel', paramObj, {
        responseType: 'blob',
    })
}
// 학생/취업준비생 - 상담 tab count
function retrieveApprovedStuCountByOjfId(ojfId) {
    return http.get(`/admin/ojf/onlineJobFair/retrieveApprovedStuCountByOjfId?ojfId=${ojfId}`);
}
// 학생/취업준비생 - 참가회원 리스트
function retrieveAllEntryStatusPaging(paramObj) {
    return http.post('/admin/ojf/entry/retrieveAllEntryStatusPaging', paramObj)
}
// 학생/취업준비생 - 이력서 리스트
function retrieveApprovedOjfResumeListAdminPaging(paramObj) {
    return http.post('/admin/ojf/ojfResume/retrieveApprovedOjfResumeListAdminPaging', paramObj)
}
// 학생/취업준비생 - 이력서 - 공개 여부 상태 변경
function updateStatusOjfResumeResOpenYnByAdmin(paramObj) {
    return http.post('/admin/ojf/ojfResume/updateStatusOjfResumeResOpenYnByAdmin', paramObj)
}
// 학생/취업준비생 - 이력서 - 입사지원 리스트
function retrieveApplicantListByResumeIdPaging(paramObj) {
    return http.post('/admin/ojf/applicant/retrieveApplicantListByResumeIdPaging', paramObj)
}
// 학생/취업준비생 - 입사지원 리스트
function retrieveAllApplicantListPaging(paramObj) {
    return http.post('/admin/ojf/applicant/retrieveAllApplicantListPaging', paramObj)
}
// 학생/취업준비생 - 받은 면접제안 리스트
function retrieveAllInterviewProposalEntryListPaging(paramObj) {
    return http.post('/admin/ojf/interviewProposalEntry/retrieveAllInterviewProposalEntryListPaging', paramObj)
}
// 학생/취업준비생 - 참가(승인)회원 엑셀 다운로드
function retrieveApprovedEntryStatusExcel(paramObj) {
    return http.post('/admin/ojf/entry/retrieveAllEntryStatusExcel', paramObj, {
        responseType: 'blob',
    })
}

export default {
    retrieveOnlineJobFairApplicantCountListPaging,
    retrieveApprovedCorpCountByOjfId,
    retrieveApprovedRecruitmentHallPaging,
    retrieveJobNoticeListPaging,
    retrieveOjfResumeListByByJobNoticeSeqAdminPaging,
    retrieveApprovedStuCountByOjfId,
    retrieveAllOjfResumeListAdminPaging,
    retrieveAllEntryStatusPaging,
    retrieveApprovedRecruitmentHallStatusExcel,
    retrieveApprovedEntryStatusExcel,
    retrieveApprovedOjfResumeListAdminPaging,
    updateStatusOjfResumeResOpenYnByAdmin,
    retrieveApplicantListByResumeIdPaging,
    retrieveAllApplicantListPaging,
    retrieveAllInterviewProposalEntryListPaging
}
